module.exports = __webpack_public_path__ + "img/11.dirty_sink.834d9dd8.svg";